"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ButtonsGroup = require("./ButtonsGroup.scss");

var _ButtonsGroup2 = _interopRequireDefault(_ButtonsGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonsGroup = function (_React$Component) {
  (0, _inherits3.default)(ButtonsGroup, _React$Component);

  function ButtonsGroup() {
    (0, _classCallCheck3.default)(this, ButtonsGroup);
    return (0, _possibleConstructorReturn3.default)(this, (ButtonsGroup.__proto__ || (0, _getPrototypeOf2.default)(ButtonsGroup)).apply(this, arguments));
  }

  (0, _createClass3.default)(ButtonsGroup, [{
    key: "render",
    value: function render() {
      var children = this.props.children;


      return _react2.default.createElement(
        "div",
        { className: _ButtonsGroup2.default.buttonsGroup },
        _react2.default.Children.map(children, function (child) {
          return _react2.default.createElement(
            "div",
            { className: _ButtonsGroup2.default.button },
            child
          );
        })
      );
    }
  }]);
  return ButtonsGroup;
}(_react2.default.Component);

exports.default = ButtonsGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/ButtonsGroup.jsx
// module id = 654
// module chunks = 0